export default __webpack_public_path__ + "static/media/clever-icon.96a9aa2f.svg";